import api from './api';

export const getTreatmentPlans = (clientId) =>
  api.get('/api/v1/treatment-plans', { params: { clientId } }).then((r) => r.data.data.plans);

export const getTreatmentPlan = (id) =>
  api.get(`/api/v1/treatment-plans/${id}`).then((r) => r.data.data.plan);

export const createTreatmentPlan = (data) =>
  api.post('/api/v1/treatment-plans', data).then((r) => r.data.data.plan);

export const updateTreatmentPlan = (id, data) =>
  api.put(`/api/v1/treatment-plans/${id}`, data).then((r) => r.data.data.plan);

export const signTreatmentPlan = (id) =>
  api.post(`/api/v1/treatment-plans/${id}/sign`).then((r) => r.data.data.plan);

export const deleteTreatmentPlan = (id) =>
  api.delete(`/api/v1/treatment-plans/${id}`).then((r) => r.data);
